import React, { useState, useEffect } from "react";
import { query, where, collection, getDocs, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import QRCode from "../../components_root/QRCode.jsx";
import Bar_code from "../../components_root/bar_code.js";
import AmountToWords from "../../components_root/AmountToWords.js";
export default function Print_receipt_order({ voucherprintid, printid }) {
    const [voucherdata, setVoucherdata] = useState(null);
    const [voucheritemsdata, setVoucheritemsdata] = useState([]);
    const [companydata, setCompanydata] = useState([]);
    const [readyToPrint, setReadyToPrint] = useState(false);
    const servicetablename = "accountingfinancedb";
    const [printdata, setPrintdata] = useState([]);
    const [stockdata, setStockdata] = useState([]);
    const [select_company_uid, setselect_company_uid] = useState(null);
    // Fetch voucher
    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherprintid) return;
            const select_company_uid = Cookies.get("select_company_uid");
            setselect_company_uid(select_company_uid);
            if (!select_company_uid) return;

            const q = query(
                collection(db, servicetablename, select_company_uid, "voucher_print"),
                where("voucherprintid", "==", voucherprintid)
            );
            const snap = await getDocs(q);
            const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            setVoucherdata(data[0] || null);
        };

        fetchVoucher();
    }, [!voucherprintid]);

    //stock
    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherprintid) return;
            const select_company_uid = Cookies.get("select_company_uid");
            setselect_company_uid(select_company_uid);
            if (!select_company_uid) return;

            const q = query(
                collection(db, servicetablename, select_company_uid, "voucher_print_stock"),
                where("voucherprintid", "==", voucherprintid)
            );
            const snap = await getDocs(q);
            const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            setStockdata(data || null);
        };

        fetchVoucher();
    }, [!voucherprintid]);
    // Load print settings
    useEffect(() => {
        if (!select_company_uid) return;

        const q = query(
            collection(db, servicetablename, select_company_uid, "print_setting"),
            where("printid", "==", printid)
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

            const settingArray = data[0]?.settingdata || [];

            // convert back to object
            const settingObj = Object.fromEntries(
                settingArray.map(item => [item.key, item.value])
            );

            setPrintdata(settingObj);
        });

        return () => unsub();
    }, [select_company_uid]);
    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherprintid) return;

            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            const docRef = doc(db, servicetablename, select_company_uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                setCompanydata({
                    id: docSnap.id,
                    ...docSnap.data()
                });
            } else {
                setCompanydata(null);
            }
        };

        fetchVoucher();
    }, [voucherprintid]);



    useEffect(() => {
        if (readyToPrint == true && voucherdata) {
            printNow();
        }
    }, [readyToPrint, voucherdata]);
    // Auto print after voucher loads
    // <title>Receipt-${voucherprintid}</title>
    const fileManagerItems = voucherdata?.filemanager
        ? Object.values(voucherdata.filemanager)
        : [];
    const FIELD_ORDER = ["title", "filenumber", "issue_date", "expiry_date"];

    const printNow = () => {
        const area = document.getElementById("print-area");
        if (!area) return;

        const content = area.innerHTML;
        
        // Create a hidden iframe for silent printing
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(`
            <html>
                <head>
                    <title>Receipt-${voucherprintid}</title>
                    <style>
                        @media print {
                            body {
                                margin: 0;
                                padding: 0;
                            }
                        }
                        body {
                            font-family: Arial;
                            width: 300px;
                            padding:10px;
                            margin: 0;
                        }
                            .bold{
                               font-weight: bold;
                            }
                                      .line1 {
        border-top: 1px solid #000;
        margin: 1px 0;
    }
    .line-bottom{
        border-bottom: 1px solid #000; 
    }
                                         .line-left {
       border-left: 1px solid #000;
        margin: 1px 0;
    } 
              .line-right {
       border-right: 1px solid #000;
        margin: 1px 0;
    }   
        .rounded {
  border-radius: 6px !important;
  
}
    .p-top
  {  margin: 3px 0px 0px 0px !important;
  }
  .p-1 {
  padding: 2px 2px !important;
}
  .box-line{
    border: 1px solid #000;
  }
                        .line {
                            border-top: 1px solid #000;
                            margin: 0px 0;
                        }
                              .line1 {
                            border-top: 1px solid #000;
                            margin: 0px 0;
                        }
                        .title {
                            text-align: center;
                            font-size: 20px;
                            text-transform: capitalize;
                            font-weight: bold;
                            margin: 5px 0;
                        }
                             .title_sub { 
                            font-size: 18px;
                            text-transform: capitalize;
                            font-weight: bold;
                            margin: 1px 0;
                        }
                                       .header-text {
                          text-transform: capitalize;
                           
                            margin: 0px 0;
                            font-size: 12px;
                        }
                                 .description-text {
                          text-transform: capitalize;
                           
                            margin: 0px 0;
                            font-size: 12px;
                        }
                                  .amount-text {
                          textAlign:right;
text-transform: capitalize;
                            font-weight: 600;
                            margin: 0px 0;
                            font-size: 12px;
                        }
                        table {
                            width: 100%;
                            font-size: 12px;
                        }
                        td {
                            padding: 2px;
                        }
                        .info-text {
                            text-align: center;
                            
                            margin: 5px 0;
                            font-size: 12px;
                        }
                        .footer-text {
                            text-align: center;
                            font-weight: bold;
                            margin: 5px 0;
                            font-size: 18px;
                        }
                        .barcode {
                            width: 250px;
                            height: auto;
                            display: block;
                            margin: 1px auto;
                        }
                        .barcode svg {
                            width: 100%;
                            height: 50px;
                        }
                            .center {
  text-align: center !important;
}
  .cap {
  text-transform: uppercase;
}

.fcap {
  text-transform: capitalize;
}
  
.text-h1 {
  font-size: 14px !important;
}

.text-h2 {
  font-size: 12px !important;
}

.text-h3 {
  font-size: 10px !important;
}

.text-h4 {
  font-size: 9px !important;
}

.text-h5 {
  font-size: 8px !important;
}

                    </style>
                </head>
                <body>${content}</body>
            </html>
        `);
        iframeDoc.close();

        // Wait for content to load then print
        iframe.onload = () => {
            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                
                // Remove iframe after printing (with delay to ensure print job starts)
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 1000);
            }, 250);
        };
    };

    if (!voucherdata) return null;
    const domain = new URL(window.location.href).hostname;
    return (
        <div>
            <div
                id="print-area"
                style={{
                    visibility: "hidden",
                    position: "absolute",
                    left: "-9999px",
                }}
            >

                <div className="title_sub bold center">
                    {printdata.print_title}
                </div>
                <div className="text-h2 bold center">
                    {printdata.print_tagline || ""}
                </div>
                <div className="text-h4 center ">
                    {printdata.print_contactinfo || ""}
                </div>
                <div className="text-h4 center bold">
                    {printdata.print_address || ""}
                </div>
                <div className="line p-top"></div>


                <table>
                    <tr>
                        <td width={90}>
                            <div className="text-h1 fcap bold">{voucherdata.voucher_type}</div>
                        </td>
                        <td className="text-h3" width={130} style={{ textAlign: "right" }}>
                            {voucherdata.date_time?.toDate ? (<>
                                {voucherdata.date_time.toDate().toLocaleDateString()}{" "}
                                {voucherdata.date_time.toDate().toLocaleTimeString()}
                            </>
                            ) : (
                                "No date"
                            )}
                            <br />
                        </td>

                    </tr>
                    <tr>
                        <td className="bold" >
                            Token: {voucherdata.tokennumber}</td>
                        <td className="text-h3" width={130} style={{ textAlign: "right" }}>
                            #{voucherdata.vouchernumber}
                        </td>

                    </tr>
                </table>
                <div className="line"></div>
                <table>
                    <tr>
                        <td  >
                            <table>
                                <tr>
                                    <td>
                                        <div className="text-h2 bold fcap">
                                            {voucherdata.namepaying || "Name n/a"}
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div className="text-h2">
                                            {voucherdata.mobile || ""}
                                        </div>
                                    </td>
                                </tr>
                                <tr>

                                    <td>
                                        <div className="text-h3 fcap">
                                            {voucherdata.addresspaying || ""}
                                        </div>
                                    </td>
                                </tr>

                            </table>
                        </td>
                        <td width={40}>
                            <QRCode
                                url={domain + "/" + voucherdata.slug}
                                size={40}
                                onReady={() => setReadyToPrint(true)}
                            />
                            <div className="text-h2 center bold">Aooz.in</div>
                        </td>

                    </tr>
                </table>

                {/* fileManagerItems */}
                <table className="text-h2">
                    <tbody>
                        {fileManagerItems.length > 0 &&
                            fileManagerItems.map((item, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td className="line1">
                                        <table>
                                            <tbody>
                                                <tr>


                                                    {/* TITLE */}
                                                    <td className="bold fcap text-h3">
                                                        {item.title || "Untitled"}
                                                    </td>

                                                    {/* FIXED ORDER FIELDS */}
                                                    {FIELD_ORDER
                                                        .filter(key => key !== "title" && key.length > 0)
                                                        .map((key) => (
                                                            <td
                                                                key={key}
                                                                style={{ textAlign: "right" }}
                                                                className=" fcap text-r text-h3 p-11"
                                                            >
                                                                {item[key] || ""}
                                                            </td>
                                                        ))}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>



                {/* stockdata */}
                <table className="text-h2 line1 line-bottom">
                    <tbody>
                        {stockdata.length > 0 &&
                            stockdata.map((row, rowIndex) => (
                                <div key={rowIndex}>

                                    {Array.isArray(row.items) &&
                                        row.items.map((item, index) => (
                                            <tr key={index}>
                                                <td className="line-right">
                                                    <table>
                                                        <tr>
                                                            <td className="bold fcap text-h2">{item.title}</td>
                                                            <td className="fcap text-h3">{item.itemname}<br /><div className="bold line1">{item.perday ? "Per Day" : "Price"}</div> </td>

                                                            <td className="bold fcap text-h3 ">₹{item.price}<br /><div className="line1" >{item.qty}</div> </td>
                                                        </tr>
                                                    </table>
                                                </td>

                                                <td className="bold line-bottom text-r" style={{ textAlign: "right" }}>

                                                    {item.amount}/-

                                                </td>



                                            </tr>
                                        ))}

                                </div>
                            ))
                        }
                        {voucheritemsdata.length > 0 ? (
                            voucherdata.items.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-h2 bold fcap line-right">{item.description || item.voucher}</td>

                                    <td className="line-bottom">{item.amount}/-</td>
                                </tr>


                            ))
                        ) : (
                            <tr>
                                <td className="text-h2 bold fcap line-right">{voucherdata.voucher}</td>
                                <td className="bold line-bottom" style={{ textAlign: "right" }}> {voucherdata.amount}/-</td>
                            </tr>
                        )}
                        {voucherdata.ledger_manager_items &&
                            voucherdata.ledger_manager_items.length > 0 && (
                                voucherdata.ledger_manager_items
                                    .filter(item => item.account_type === "charges")
                                    .map((item, index) => (
                                        <tr key={index}>
                                            <td className="text-h2 fcap line-right">{item.managename || item.voucher}</td>
                                            <td className="bold line-bottom" style={{ textAlign: "right" }}>
                                                {item.amount}/- {item.mathedcalc === "=" ? ("") : (item.mathedcalc)}
                                            </td>
                                        </tr>
                                    ))
                            )
                        }


                        {typeof voucherdata.eventdate?.toDate === "function" &&
                            voucherdata.eventstatus === true && (
                                <tr>
                                    <td className="text-h2 bold line-right">
                                        Event date:<br />
                                        {voucherdata.eventdate.toDate().toLocaleDateString()}{" "}
                                        {voucherdata.eventdate.toDate().toLocaleTimeString()}
                                    </td>
                                    <td></td>
                                </tr>
                            )}
                        <tr>
                            <td className="text-h2 line-right">
                                {voucherdata.refer_number != null && voucherdata.refer_number !== "" &&
                                    `Refer No.: ${voucherdata.refer_number}`}
                            </td>
                            <td> </td>
                        </tr>
                        <tr>
                            <td className="text-h3 fcap line-right">{voucherdata.remarks || ""}</td>
                            <td> </td>
                        </tr>

                        <tr  >
                            <td className="line-right line1"><b className="text-h2 bold">TOTAL AMOUNT</b></td>
                            <td className="line1" style={{ textAlign: "right" }}>
                                <b className="text-h1 ">₹ {voucherdata.totalamount}/-</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tr>
                        <td>
                            <div className="text-h4 bold">
                                <AmountToWords amount={voucherdata.totalamount} />   </div>
                        </td>
                        <td width={50}>
                            <a>
                                {voucherdata.payment_method_online ? <a className="text-h3" >Pay: Online</a> : <a className="text-h3">Pay: Cash</a>} </a>
                        </td>
                    </tr>
                </table>





                {/* <table>
                    <tr>
                        <td><b>CASH</b></td>
                        <td style={{ textAlign: "right" }}>₹ {voucherdata.totalamount}</td>
                    </tr>
                    <tr>
                        <td><b>CHANGE</b></td>
                        <td style={{ textAlign: "right" }}>₹ 0</td>
                    </tr>
                </table> */}
                <div className="text-h5 p-top">
                    {printdata.print_trams_footer || ""}
                </div>
                <div className="text-h4 bold">
                    {printdata.print_contact_info_footer || ""}
                </div>
                <div className="text-h4 bold">
                    {printdata.print_address_footer || ""}
                </div>
                <div style={{ textAlign: "left" }} className="barcode p-top">
                    <Bar_code value={voucherdata.vouchernumber} code={true} />
                </div>
                <div className="text-h2 center bold">THANK YOU</div>
                <div className="text-h4" style={{ textAlign: "right", borderBottom: "1px solid #000", width: "150px", marginLeft: "auto" }}>Authority Signature</div>
                <div className="text-h4 p-top" style={{ textAlign: "right" }}>{new Date().toLocaleString()}</div>

            </div>

        </div>
    );
}
